import img1 from '../../Assets/virtualTour.jpeg';
import './AboutPageElementCss/ReachOutSection.css';
export default function ReachOutUsSection(){
    return(
        <>
            <div className="reachOutUsSection">
                <img src={img1} alt="RBD banner" />
            </div>
        </>
    )
}